var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoaded)?_c('identity-template',{attrs:{"last-name":_vm.lastName,"phone":_vm.phone,"phone-iso-code":_vm.patientPhoneIsoCode,"sms-accepted":_vm.smsAccepted,"marketing-sms-offers-accepted":_vm.marketingSmsOffersAccepted,"phone-countries":_vm.$options.phoneCountries,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }